import React, { useEffect, useMemo, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { Button, Input, Text } from 'components/atomic'
import axios from 'axios'
import { dkProductCrate } from 'lib/constants'
// import { useUserMetadataQuery } from 'generated/graphql'

interface TransferConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  email: string
  crateCount: number
  receiverUserId: string
  onTransferSuccess: () => void
}

export default function TransferConfirmModal({
  isOpen,
  onClose,
  email,
  crateCount,
  receiverUserId,
  onTransferSuccess,
}: TransferConfirmModalProps) {
  // const { loading, data, error } = useUserMetadataQuery()
  // const otpHashExpiresAt = data?.users_metadata[0]?.user.otpHashExpiresAt

  // const isOtpHashExpired = useMemo(() => {
  //   if (!otpHashExpiresAt) return true
  //   return new Date() > new Date(otpHashExpiresAt)
  // }, [otpHashExpiresAt])

  const [isLoading, setIsLoading] = useState(false)
  const [otp, setOtp] = useState<string>('')

  const handleOTP = async () => {
    try {
      const response = await axios.get('/api/otp-email-elevated-auth')
    } catch (error) {}
  }

  useEffect(() => {
    if (
      isOpen
      //  && !loading && otpHashExpiresAt && isOtpHashExpired
    ) {
      handleOTP()
    }
  }, [isOpen])

  const handleOTPChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOtp(event.target.value)
  }

  const handleTransfer = async () => {
    try {
      setIsLoading(true)
      await axios.post('/api/transfer-exotics', {
        receiverUserId,
        quantity: crateCount,
        productName: dkProductCrate,
        otp,
      })
      onTransferSuccess()
      onClose()
    } catch (error) {
      console.log(error.response.data)
      alert(error.response.data)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Transition appear show={isOpen} as={React.Fragment}>
      <Dialog as="div" className="relative z-[11]" onClose={() => {}}>
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-blackish p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title as="h3" className="mb-4 text-center text-xl font-medium leading-6 text-white">
                  Confirm Transfer
                </Dialog.Title>
                <div>
                  <Text className="text-center text-white">
                    Are you sure you want to transfer {crateCount} crates to {email}?
                  </Text>

                  <br />

                  {/* {isOtpHashExpired && ( */}
                  <div className="mb-4 flex flex-col items-center">
                    <Text className="mb-2">Confirm by pasting code sent to your email:</Text>
                    <Input label="" disabled={isLoading} value={otp} onChange={handleOTPChange} />
                  </div>
                  {/* )} */}
                </div>

                <div className="flex justify-center">
                  <Button
                    size="small"
                    onClick={handleTransfer}
                    className="mr-2"
                    state={isLoading || !otp ? 'disabled' : ''}
                  >
                    Confirm
                  </Button>
                  <Button size="small" variant="secondary" onClick={onClose} state={isLoading ? 'disabled' : ''}>
                    Cancel
                  </Button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
